import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Spinner } from '@td-client-frontend/common';
import { useAuth } from '../../context/AuthContext';
import { Transition } from '@headlessui/react';

const sleep = (ms: number) => new Promise((resolve, reject) => setTimeout(resolve, ms));

export function AuthorizationRedirect() {
  const [loading, setLoading] = useState(true);
  const [target, setTarget] = useState('/no-permissions');
  const { manualCheck } = useAuth();

  useEffect(() => {
    const checkPermissionsForRedirect = async () => {
      // this sleep(2000) was added because the manualCheck session sometimes fails
      // to come back with permissions if called to quickly. It"s probably an issue with the backend and TAS
      sleep(2000);
      try {
        await manualCheck();
        setTarget('/home');
        setLoading(false);
      } catch (e) {
        setTarget('/no-permissions');
        setLoading(false);
      }
    };

    checkPermissionsForRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Transition show={loading} appear>
        <div className="absolute inset-0 overflow-y-auto" style={{ zIndex: 60 }}>
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              enter="ease-out duration-100"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-75"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 z-auto transition-opacity bg-black bg-opacity-25" aria-hidden="true" />
            </Transition.Child>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <div className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-lg sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto -mt-2 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                    <Spinner />
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h2 className="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                      Loading Permissions
                    </h2>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        This is currently loading all of the permissions associated with your account. Please contact
                        your administrator if your permissions are incorrect or you do not have access to certain pages.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    );
  }

  return <Redirect to={target} />;
}
